import { takeLatest, all, select } from 'redux-saga/effects';
import { maybeOpenInNewTab } from 'src/utils/commonUtils';
import { getIsWebview } from 'src/store/view/selectors';
import { OPERATOR_QUERY_PARAM_KEY } from '../../../../constants/filters';
import { selectedOperatorsArraySelector } from '../selectors/searcher';
import { openOfferAction } from '../actions/offer';

function* handleOfferClicked({ payload }: ReturnType<typeof openOfferAction>) {
  const { link } = payload;
  const operatorsIds = yield select(selectedOperatorsArraySelector);
  const formattedTOIds = operatorsIds
    .map((operatorId) => `${OPERATOR_QUERY_PARAM_KEY}[]=${operatorId}`)
    .join('&');
  const linkWithTOFilters = `${link}&${formattedTOIds}`;

  const isWebview = yield select(getIsWebview);
  const offerLink = operatorsIds.length ? linkWithTOFilters : link;

  maybeOpenInNewTab(offerLink, isWebview);
}

export default function* () {
  yield all([takeLatest(openOfferAction.type, handleOfferClicked)]);
}
